import { theme } from '@/hant/tailwind';
import { StandaloneImage } from 'base/components/Image';

export const HantStandaloneImage: typeof StandaloneImage = ({ options, ...props }) => {
  const maxContentWidth = theme.extend.maxWidth.tabloid;
  const sizes = `(max-width: ${maxContentWidth}) 100vw, ${maxContentWidth}`;

  return <StandaloneImage options={{ ...options, sizes, maxWidth: 980 }} {...props} />;
};

export default HantStandaloneImage;
